/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierEmail
 */
export interface CarrierEmail {
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  carrierEmailId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  graphConversationId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  graphMessageId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  internetMessageId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  fromHandle?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  fromName?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  toHandles?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  ccHandles?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierEmail
   */
  sentAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  bodyText?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  bodyHtml?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  messagesJson?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  attachmentsJson?: string;
  /**
   *
   * @type {number}
   * @memberof CarrierEmail
   */
  messageCount?: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierEmail
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierEmail
   */
  createdBy?: string;
}

/**
 * Check if a given object implements the CarrierEmail interface.
 */
export function instanceOfCarrierEmail(value: object): value is CarrierEmail {
  return true;
}

export function CarrierEmailFromJSON(json: any): CarrierEmail {
  return CarrierEmailFromJSONTyped(json, false);
}

export function CarrierEmailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierEmail {
  if (json == null) {
    return json;
  }
  return {
    carrierEmailId:
      json["carrierEmailId"] == null ? undefined : json["carrierEmailId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    graphConversationId:
      json["graphConversationId"] == null
        ? undefined
        : json["graphConversationId"],
    graphMessageId:
      json["graphMessageId"] == null ? undefined : json["graphMessageId"],
    internetMessageId:
      json["internetMessageId"] == null ? undefined : json["internetMessageId"],
    subject: json["subject"] == null ? undefined : json["subject"],
    fromHandle: json["fromHandle"] == null ? undefined : json["fromHandle"],
    fromName: json["fromName"] == null ? undefined : json["fromName"],
    toHandles: json["toHandles"] == null ? undefined : json["toHandles"],
    ccHandles: json["ccHandles"] == null ? undefined : json["ccHandles"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    bodyText: json["bodyText"] == null ? undefined : json["bodyText"],
    bodyHtml: json["bodyHtml"] == null ? undefined : json["bodyHtml"],
    messagesJson:
      json["messagesJson"] == null ? undefined : json["messagesJson"],
    attachmentsJson:
      json["attachmentsJson"] == null ? undefined : json["attachmentsJson"],
    messageCount:
      json["messageCount"] == null ? undefined : json["messageCount"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
  };
}

export function CarrierEmailToJSON(json: any): CarrierEmail {
  return CarrierEmailToJSONTyped(json, false);
}

export function CarrierEmailToJSONTyped(
  value?: CarrierEmail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierEmailId: value["carrierEmailId"],
    carrierIdentifier: value["carrierIdentifier"],
    graphConversationId: value["graphConversationId"],
    graphMessageId: value["graphMessageId"],
    internetMessageId: value["internetMessageId"],
    subject: value["subject"],
    fromHandle: value["fromHandle"],
    fromName: value["fromName"],
    toHandles: value["toHandles"],
    ccHandles: value["ccHandles"],
    sentAt: value["sentAt"],
    bodyText: value["bodyText"],
    bodyHtml: value["bodyHtml"],
    messagesJson: value["messagesJson"],
    attachmentsJson: value["attachmentsJson"],
    messageCount: value["messageCount"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
  };
}
